var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0822 5.66711L12.3728 5.3462L15.786 1.57723C15.8206 1.53902 15.851 1.49792 15.8772 1.45464C16.0671 1.14113 16.0367 0.713148 15.786 0.436306C15.5007 0.121248 15.0381 0.121248 14.7528 0.436306L14.6507 0.549051L11.2239 4.33292L10.9333 4.65383L8 7.89287L5.06668 4.65383L4.77606 4.33292L1.34933 0.54905L1.24723 0.436306C0.961909 0.121248 0.499312 0.121248 0.213991 0.436306C-0.0367203 0.713148 -0.0671311 1.14113 0.122759 1.45464C0.148972 1.49792 0.179382 1.53902 0.213991 1.57723L3.62722 5.3462L3.91784 5.66711L7.34456 9.45097L7.44667 9.56372C7.59867 9.73156 7.80098 9.80999 8 9.799C8.19902 9.80999 8.40133 9.73156 8.55334 9.56372L8.65544 9.45097L12.0822 5.66711Z",
    fill: "#B8EDE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownWhite);
export default __webpack_public_path__ + "static/media/arrow-down-white.9b49023feb719d4b764729f279ade339.svg";
export { ForwardRef as ReactComponent };